import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _asyncToGenerator from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _defineProperty from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _intersection from "lodash/intersection";
import _regeneratorRuntime from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import "core-js/modules/es6.object.keys.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { CELL_SETS_UPDATE_PROPERTY } from 'redux/actionTypes/cellSets';
import fetchAPI from 'utils/http/fetchAPI';
import endUserMessages from 'utils/endUserMessages';
import handleError from 'utils/http/handleError';
import getCellSets from 'redux/selectors/cellSets/getCellSets';
var updateCellSetPropertyJsonMerger = function updateCellSetPropertyJsonMerger(cellSetKey, dataUpdated, cellClassKey) {
  return [{
    $match: {
      query: "$[?(@.key == \"".concat(cellClassKey, "\")]"),
      value: {
        children: [{
          $match: {
            query: "$[?(@.key == \"".concat(cellSetKey, "\")]"),
            value: _objectSpread({}, dataUpdated)
          }
        }]
      }
    }
  }];
};
var updateCellClassPropertyJsonMerger = function updateCellClassPropertyJsonMerger(cellClassKey, dataUpdated) {
  return [{
    $match: {
      query: "$[?(@.key == \"".concat(cellClassKey, "\")]"),
      value: _objectSpread({}, dataUpdated)
    }
  }];
};
var cellClassAllowedKeys = ['name'];
var cellSetAllowedKeys = ['name', 'color'];
var updatesAreAllowed = function updatesAreAllowed(dataUpdated, rootNode) {
  var allowedPropertyKeys = rootNode ? cellClassAllowedKeys : cellSetAllowedKeys;
  var dataUpdatedKeys = Object.keys(dataUpdated);
  return _intersection(dataUpdatedKeys, allowedPropertyKeys).length === dataUpdatedKeys.length;
};
var updateCellSetProperty = function updateCellSetProperty(experimentId, key, dataUpdated) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch, getState) {
      var _getCellSets, loading, error, properties, _properties$key, parentNodeKey, rootNode, jsonMergerUpdateObject;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _getCellSets = getCellSets()(getState().cellSets), loading = _getCellSets.loading, error = _getCellSets.error, properties = _getCellSets.properties;
            if (!(loading || error)) {
              _context.next = 3;
              break;
            }
            return _context.abrupt("return", null);
          case 3:
            _properties$key = properties[key], parentNodeKey = _properties$key.parentNodeKey, rootNode = _properties$key.rootNode;
            if (updatesAreAllowed(dataUpdated, rootNode)) {
              _context.next = 6;
              break;
            }
            throw new Error('Invalid cell set update');
          case 6:
            jsonMergerUpdateObject = rootNode ? updateCellClassPropertyJsonMerger(key, dataUpdated) : updateCellSetPropertyJsonMerger(key, dataUpdated, parentNodeKey);
            _context.prev = 7;
            _context.next = 10;
            return fetchAPI("/v2/experiments/".concat(experimentId, "/cellSets"), {
              method: 'PATCH',
              headers: {
                'Content-Type': 'application/boschni-json-merger+json'
              },
              body: JSON.stringify(jsonMergerUpdateObject)
            });
          case 10:
            _context.next = 12;
            return dispatch({
              type: CELL_SETS_UPDATE_PROPERTY,
              payload: {
                cellSetKey: key,
                dataUpdated: dataUpdated
              }
            });
          case 12:
            _context.next = 17;
            break;
          case 14:
            _context.prev = 14;
            _context.t0 = _context["catch"](7);
            handleError(_context.t0, endUserMessages.ERROR_SAVING);
          case 17:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[7, 14]]);
    }));
    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
};
export default updateCellSetProperty;